import React from 'react';
import { Button } from 'react-bootstrap';
import ActivityLoader from './ActivityLoader';
import styles from './css/LoadableFallback.module.css';

/**
 * react-loadable loading component. Shows spinner while importing and a visible
 * error with retry when the dynamic import fails.
 */
export default function LoadableFallback({
  isLoading,
  pastDelay,
  timedOut,
  error,
  retry,
}) {
  if (error) {
    const message =
      error && error.message ? error.message : String(error || 'Unknown error');

    return (
      <div className={styles.errorPanel} role="alert">
        <p className={styles.errorTitle}>Failed to load page</p>
        <p className={styles.errorMessage}>{message}</p>
        {timedOut ? (
          <p className={styles.errorHint}>The request timed out.</p>
        ) : null}
        {typeof retry === 'function' ? (
          <Button className={styles.retryButton} onClick={retry}>
            Retry
          </Button>
        ) : null}
      </div>
    );
  }

  if (isLoading && pastDelay) {
    return <ActivityLoader show />;
  }

  return null;
}
